/**
 * Get all linkable items (assets and liabilities) for vault file linking
 * Uses headerSearchItems which already handles deduplication naturally
 * @param {Object} metadataStore - The metadata store instance
 * @param {Set} initiallySelectedIds - Set of initially selected item IDs (optional)
 * @returns {Array} Array of formatted linkable items
 */
export const getAllLinkableItems = (metadataStore, initiallySelectedIds = new Set()) => {
    if (!metadataStore.headerSearchItems) {
        return [];
    }

    return metadataStore.headerSearchItems.map(item => ({
        ...item,
        categoryClass: {
            id: item.classId,
            title: item.classTitle,
            color: item.classColor,
            icon: item.classIcon
        },
        category: { id: item.categoryId, title: item.categoryTitle },
        type: item.classId === 10 ? 'liability' : 'asset',
        wasSelected: initiallySelectedIds.has(item.id)
    }));
}; 